import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type ForgetPasswordRequestData = {
    login: string,
};

function forgetPassword(data: ForgetPasswordRequestData): Promise<DefaultResponseData> {
    return fetchData('api/forget_password', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { forgetPassword };
